import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Machine } from "@interfaces/models/machine.interface";
import { Service } from "@services/service";
import { Guid } from "guid-typescript";

@Injectable()
export class ToolHolderMachineService extends Service {
	constructor(injector: Injector) {
		super("ToolHolderMachine", injector);
	}

	// API
	forMachine(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForMachine/${id}`);
	}

	forToolHolder(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForToolHolder/${id}`);
	}

	updateMachinesForToolHolder(lookupId: Guid, data: Machine[]) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/UpdateMachinesForToolHolder/${lookupId}`, data);
	}
}
